const Credit = () => {

    return (
        <div className="credit">
          <div className="wrapper">
            <div className="scroll-text">
              <h1>Special Thanks to...</h1>
              <h2>HPE Presales Team</h2>
                <p>K.Pinit Boonpornpichet <span style={{color: '#7630EA'}}>(Supervisor)</span></p>
                <p>K.Wanchanok Ketwichian <span style={{color: '#7630EA'}}>(Mentor)</span></p>
                <p>K.Sasichai Ruttananuntawatee <span style={{color: '#7630EA'}}>(Mentor)</span></p>
                <p>K.Juthamas Boonjaroen <span style={{color: '#7630EA'}}>(Front-end and UI Design Consultation)</span></p>
                <p>K.Unyarat kuasombat</p>
                <p>K.Tanai hongtiemjan</p>
                <p>K.Nattawut dejkajonwuth</p>
                <p>K.Ravipol Kulatumyotin <span style={{color: '#7630EA'}}>(Moral Support)</span></p>
                <p>K.Peerawit Khetsakun</p>
                <p>K.Sadit Indramangala <span style={{color: '#7630EA'}}>(Data Security Consultant)</span></p>
                <p>K.Chaiphong Jarunavin <span style={{color: '#7630EA'}}>(Moral Support)</span></p>
            </div>
          </div>
        </div>
    );
}
 
export default Credit;